import instance from "./ApiServices";
const API_URL = "/auth/";

const login = async (email, password) => {
  try {
    //I also tried using only: "/send_mail" here like I have in server.js but it didnt work
    return await instance
      .post(API_URL + "login", {
        email,
        password,
      })
      .then((response) => {
        // console.log("Response Service:" + JSON.stringify(response.data));
        if (response.data) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response;
        // return response.data;
      });
  } catch (error) {
    return error.response;
  }
};

const logout = () => {
  localStorage.removeItem("user");
};

const register = (name, email, password, password_confirmation) => {
  return instance.post(API_URL + "register/", {
    name,
    email,
    password,
    password_confirmation,
  });
};

const getCurrentUser = () => {
  // console.log("Current user:"+localStorage.getItem('user'))
  return JSON.parse(localStorage.getItem("user"));
};

const forgotpassword = async (email) => {
  try {
    //I also tried using only: "/send_mail" here like I have in server.js but it didnt work
    return await instance
      .post(API_URL + "forgot-password", {
        email,
      })
      .then((response) => {
        console.log(response.data);
        return response;
      });
  } catch (error) {
    return error.response;
  }
};

const savepassword = async (token, email, password, password_confirmation) => {
  // console.log("Received:" + password);
  try {
    //I also tried using only: "/send_mail" here like I have in server.js but it didnt work
    return await instance
      .post(API_URL + "save-password", {
        token,
        email,
        password,
        password_confirmation,
      })
      .then((response) => {
        // console.log("Returned some:" + JSON.stringify(response));
        return response;
        // return response.data;
      });
  } catch (error) {
    return error.response;
  }
};

const AuthService = {
  login,
  logout,
  register,
  getCurrentUser,
  forgotpassword,
  savepassword,
};

export default AuthService;
